import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const usePopularUserClickAnalytics = () => {
  const handlePopularUserClick = (id: number) => {
    TrackingApi.trackClick({
      info: 'top_users',
      value: id,
      screen: getScreenOrientationWithSizes(),
    }).catch((err) => err);
  };

  return {
    handlePopularUserClick,
  };
};
